import { useEffect, useState } from "react";

const services = [
  {
    number: "01",
    title: "Contractor Supervision",
    description: "Independent oversight of every contractor on your project — no conflicts of interest.",
  },
  {
    number: "02",
    title: "Milestone Verification",
    description: "Every milestone is documented, photographed, and approved before payment is released.",
  },
  {
    number: "03",
    title: "Progress Reporting",
    description: "Weekly reports with clear KPIs, blockers, and forward plan delivered to your inbox.",
  },
  {
    number: "04",
    title: "Risk Management",
    description: "Early detection of cost, schedule, and quality risks with mitigation plans.",
  },
  {
    number: "05",
    title: "Quality Assurance",
    description: "On-site and remote inspections by domain experts with photographic evidence.",
  },
  {
    number: "06",
    title: "Vendor Vetting",
    description: "Background, capability and reference checks before any contractor is onboarded.",
  },
];

export function ServicesSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.getElementById("services-section");
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="services-section" className="relative py-24 md:py-32 lg:py-40 bg-muted/30">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16">
          <h2
            className={`text-5xl md:text-6xl lg:text-7xl font-display tracking-tight leading-[1.1] transition-all duration-1000 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            What we deliver.
          </h2>
          <p
            className={`text-xl text-muted-foreground mt-6 leading-relaxed max-w-2xl transition-all duration-1000 delay-100 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            We act as your independent eyes and hands on the ground. Our supervisors are domain experts — construction managers, technologists, engineers — accountable only to you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {services.map((service, index) => (
            <div
              key={index}
              className={`transition-all duration-1000 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${100 + index * 80}ms` }}
            >
              <div className="flex items-start gap-4">
                <span className="text-4xl font-display text-muted-foreground flex-shrink-0">
                  {service.number}
                </span>
                <div>
                  <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
